import { render, staticRenderFns } from "./HotKeywords.vue?vue&type=template&id=04f74745&scoped=true"
import script from "./HotKeywords.vue?vue&type=script&lang=js"
export * from "./HotKeywords.vue?vue&type=script&lang=js"
import style0 from "./HotKeywords.vue?vue&type=style&index=0&id=04f74745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f74745",
  null
  
)

export default component.exports